import { Tooltip as BasicTooltip } from '@bedrock/components';
import './index.less';

export default BasicTooltip;
